import type * as Repository from "@/components/features/hotel-notification-settings/model/repository";
import type * as FormModelType from "@/components/features/hotel-notification-settings/model/type";

export const serverModelToInputModelConverter = (
	serverModel: Repository.Query.ServerModel,
): FormModelType.HotelNotificationSettingFormModel["InputModel"] => {
	const { hotelNotificationSetting } = serverModel;
	return hotelNotificationSetting;
};
